// import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
// import AboutImg from "../assets/night.jpg";
import Footer from "../components/Footer";
import Service2 from "../components/Service2";
// import Image13 from "../assets/13.jpg"

function service2() {
  return (
    <>
      <Navbar />
      {/* <Hero
        cName='hero-mid'
        heroImg={Image13}
        // title='Service'
        // text='We providing you the Services as ....'
        // buttonText='Get in Touch'
        // url='/'
        btnClass='hide'
       /> */}
       <Service2 />
       <Footer/>
    </>
  );
}

export default service2;
